<template>
  <div id="compreSportsMeet_players" v-show="currThemeObj">
    <div class="select_area">
      <marathon_select_opt
        :currThemeObj="currThemeObj"
        :data="selectOptData"
        :inputObject="select_opt_inputObject"
        @changeSelectEvent="changeSelect"
        @inputValEvent="inputValHandler"
      ></marathon_select_opt>
    </div>
    <div class="teamTable">
      <div class="tableScrollArea" ref="tableParentDom">
        <!-- <div class="match_label_fixed" v-show="curMatchLabelFixedIcon">
          <div class="match_label">
            <span class="label_textArea">
              <span class="labelIcon">
                <img :src="currBigSports.icon" />
              </span>
              <span
                :class="[
                  currBigSports.label && currBigSports.label.length === 2
                    ? 'letterSpa'
                    : '',
                ]"
                v-text="currBigSports.label"
              ></span>
            </span>
            <span class="label_rightArea">
              <span
                class="rightArea_name"
                v-text="currBigSports.rightText"
              ></span>
              <span
                class="rightArea_value"
                v-text="currBigSports.rigthNum"
              ></span>
            </span>
          </div>
        </div> -->
        <div :class="scrollDomClassName">
          <div class="players_list">
            <playerItem
              v-for="item in matchList"
              :currCid="currCid"
              :key="item.playerId"
              :item="item"
              :mode="playerMode"
              :detailPathName="detailPathName"
              :fromPage="currPage"
            ></playerItem>
          </div>
        </div>
        <p class="loadingClass" v-show="loading">加载中...</p>
        <p class="noMoreClass" v-show="noMore">没有更多了</p>
        <p class="noDataClass" v-show="noData">暂无数据</p>
      </div>
    </div>
    <BackTop :showBackTop="showBackTop" :clickEvent="goBackTop"></BackTop>
  </div>
</template>

<script>
import {
  https_select_delegationList,
  https_sportsList,
  https_playerList,
} from '@api/platfrom_compreSportsMeet_api'
import BackTop from '@components/base/backTop.vue'
import marathon_select_opt from '@components/platfromBase/marathon/select_opt.vue'
import playerItem from '@components/platfromBase/compreSportsMeet/playerList_itemPanel.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'compreSportsMeet_players',
  components: {
    marathon_select_opt,
    playerItem,
    BackTop,
  },
  mixins: [cup_base_data_mixin],
  data() {
    return {
      currPage: 'CSMeetPlayerIndex',
      playerMode: 'mode_sports',
      detailPathName: 'CSMeetPlayerDetailIndex',
      select_opt_inputObject: {
        inputTitle: '运动员',
        placeholder: '请输入运动员名称',
        iconType: 'player',
      }, //控制marathon_select_opt中的输入框是否显示
      isScrollBottom: false,
      scrollDomClassName: 'scrollDomContain',
      scrollDomById: 'containerFull_body',
      loading: false,
      curMatchLabelFixedIcon: null,
      matchItemPbpx: 0,
      matchTotal: null,
      matchList: null,
      bigSportsArr: [],
      delegationArr: [],
      curInputVal: '',
      currStageBigSports: '',
      currStageDelegation: '',
      selectOptData: {
        configArr: [
          {
            type: 'delegation',
            title: '代表团',
            origin_keyVal: ['value', 'name'],
            dataName: 'delegationArr',
            selectIndex: 0,
            isFilterable: true,
          },
          {
            type: 'bigSports',
            title: '项目',
            origin_keyVal: ['value', 'name'],
            dataName: 'bigSportsArr',
            selectIndex: 0,
            isFilterable: true,
          },
        ],
        selectOpt_list: [],
      },
      actSelectIndexArr: [0, 0],
      showBackTop: false,
    }
  },
  beforeCreate() {},
  created() {
    this.query = this.$route.query
    this.init()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', () => {
      this.scrollListenerEvent()
    })
  },
  computed: {
    noMore() {
      // return this.matchTotal !== 0 && this.isScrollBottom
      return this.matchList !== 0 && this.matchList && this.matchList.length > 0
    },
    noData() {
      return this.matchList && this.matchList.length == 0
    },
    tableHeightPx() {
      let clientHeight = window.innerHeight
        ? window.innerHeight
        : window.screen.height
        ? window.screen.height
        : 667
      let clientWidth = window.innerWidth
        ? window.innerWidth
        : window.screen.width
        ? window.screen.width
        : 375

      return Math.floor(clientHeight - (clientWidth / 100) * (42 - 26))
      // return 500
    },
  },
  methods: {
    async init() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      console.debug(this.currCid, this.currSid)
      this.currPlayerIndexPage = JSON.parse(
        this.$localStorage.getItem('mixtmt_platfromV4_currPlayerIndexPage')
      )
      await this.getDelegationList()
      await this.getBigSportsList()
      await this.getDelegationDetailPlayerList()
      console.debug(this.stageArr, this.currPlayerIndexPage)
      this.computedSelectOpt(
        this.selectOptData.configArr,
        this.actSelectIndexArr
      )

      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    inputValHandler(inputVal) {
      // 获取inputVal值
      console.debug('inputVal:', inputVal)
      this.curInputVal = inputVal
      this.getDelegationDetailPlayerList()
    },
    scrollListenerEvent() {
      const scrollTop = this.scrollAreaDom.scrollTop
      const scrollHeight = this.scrollAreaDom.scrollHeight
      const parentHeightPx = this.scrollAreaDom.offsetHeight
      let direction = this.DIRECTION_ENUM.DOWN
      if (this.beforeScrollTop > scrollTop) {
        direction = this.DIRECTION_ENUM.UP
      }
      // 通过滚动方向判断是触底还是触顶
      // console.debug(
      //   'direction:',
      //   direction,
      //   scrollTop,
      //   parentHeightPx,
      //   scrollHeight,
      //   this.isScrollBottom
      // )

      if (scrollTop > 300) {
        this.showBackTop = true
      } else {
        this.showBackTop = false
      }

      // this.changeMatchLabelFixed(scrollTop, direction)

      if (direction == this.DIRECTION_ENUM.DOWN) {
        // 滚动触底
        if (scrollTop + parentHeightPx + this.threshold >= scrollHeight) {
          console.debug('滚动触底')
          this.isScrollBottom = true
        }
      } else {
        // 滚动到顶部
        this.isScrollBottom = false
        if (scrollTop <= this.threshold) {
          console.debug('滚动到顶部')
        }
      }

      this.beforeScrollTop = this.scrollAreaDom.scrollTop
    },
    goBackTop() {
      if (this.scrollAreaDom) {
        this.scrollAreaDom.scrollTo(0, 0)
      }
    },
    initScroll() {
      if (this.scrollAreaDom) {
        return
      }
      this.beforeScrollTop = 0
      this.threshold = 5
      this.DIRECTION_ENUM = {
        DOWN: 'down',
        UP: 'up',
      }
      // this.scrollAreaDom = document.getElementsByClassName(
      //   `${this.scrollDomClassName}`
      // )[0]
      this.scrollAreaDom = document.getElementById(`${this.scrollDomById}`)

      this.scrollAreaDom.addEventListener('scroll', () => {
        this.scrollListenerEvent()
      })
    },
    computedSelectOpt(configArr, actSelectIndexArr) {
      console.debug(actSelectIndexArr)
      // 组装选择框数据
      let selectOpt_list = []
      configArr.forEach((config, index) => {
        let disabledArr = []
        const mix_id = `mix_${config.origin_keyVal[0]}`
        let list = this[config.dataName].map((item) => {
          item[mix_id] = `${config.type}_${item[config.origin_keyVal[0]]}`
          return item
        })
        console.debug(
          'computedSelectOpt:',
          config.dataName,
          this[config.dataName],
          list,
          mix_id
        )
        let selectIndex = config.selectIndex
        if (actSelectIndexArr && actSelectIndexArr.length > 0) {
          selectIndex = actSelectIndexArr[index] ? actSelectIndexArr[index] : 0
        }
        selectOpt_list.push({
          type: config.type,
          title: config.title,
          keyVal: [mix_id, config.origin_keyVal[1]],
          curId: list[selectIndex][mix_id], // 选中的id,是改装后的，需要去掉前缀才是源数据的唯一id
          curVal: list[selectIndex][config.origin_keyVal[1]], // 这个值是源数据需要展示的值，没有做过修改
          disabledArr, //当【阶段】选择为淘汰赛时，球队这栏置灰；所以在【球队】这组对象的disabledArr=['stage_2']；而【阶段】的disabledArr = []。在marathon_select_opt组件中也需要做一些逻辑处理，主要是对curStageVal这个值
          isFilterable: config.isFilterable ? config.isFilterable : false,
          list,
        })
      })

      this.selectOptData.selectOpt_list = selectOpt_list
      console.debug('this.selectOptData.selectOpt_list', selectOpt_list)
    },
    changeSelect(data) {
      console.debug(data)
      let valPathArr = []
      let val = data.val
      // 选择后，重置联动的筛选框
      // let updateSelectIndex = -1
      if (data.type === 'select') {
        if (val.indexOf('_') > -1) {
          valPathArr = val.split('_')
          for (let i = 0; i < this.selectOptData.selectOpt_list.length; i++) {
            let item = this.selectOptData.selectOpt_list[i]
            const idKey = item.keyVal[0]
            const valKey = item.keyVal[1]
            if (item.type == valPathArr[0]) {
              for (let j = 0; j < item.list.length; j++) {
                let cell = item.list[j]
                console.debug(idKey, val)
                if (cell[idKey] == val) {
                  console.debug(cell[idKey], val)
                  // updateSelectIndex = i
                  item.curVal = cell[valKey]
                  break
                }
              }
            }
          }
          if (valPathArr[0] === 'delegation') {
            this.currStageDelegation = valPathArr[1]
          } else if (valPathArr[0] === 'bigSports') {
            this.currStageBigSports = valPathArr[1]
          } else {
          }
          // 筛选表格逻辑
          this.getDelegationDetailPlayerList()
        } else {
          console.debug('id命名方式不符合组件规则')
        }
      } else {
        console.debug('data.type 没有匹配成功')
      }
    },
    computedMatchList(group) {
      console.debug('computedMatchList:', group)
      let matchList = []
      if (group && group.length > 0) {
        matchList = group.map((item) => {
          return {
            playerId: item.athleteCode,
            playerName: item.athleteName,
            playerLogo: item.athleteLogo,
            gender: item.gender,
            birthDate: '',
            height: '',
            weight: '',
            sportsId: item.disciplineCode,
            sportCN: item.disciplineName,
            delegationId: item.organisationCode,
            delegationLogo: item.organisationLogo,
            delegationName: item.organisationName,
          }
        })
      }
      this.matchList = matchList
      console.debug('computedMatchList end:', matchList)
    },
    async getDelegationDetailPlayerList() {
      await https_playerList(this.axiosBaseUrl, this.$axios, {
        sid: this.currSid,
        delegationId: this.currStageDelegation ? this.currStageDelegation : '',
        sportsId: this.currStageBigSports ? this.currStageBigSports : '',
        name: this.curInputVal,
      })
        .then((response) => {
          const res = response.data
          console.debug('response:', res)
          if (res.status === 0) {
            if (res.data) {
              this.matchTotal =
                res.data && res.data.length ? res.data.length : 0
              this.computedMatchList(res.data)
              this.initScroll()
            } else {
              console.debug('暂无数据')
            }
            console.debug('暂无数据:', this.matchTotal, this.matchList)
            this.$nextTick(() => {
              this.loading = false
              // this.getScheduleMatchListDomHeigt()
            })
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getDelegationList() {
      await https_select_delegationList(this.axiosBaseUrl, this.$axios, {
        sid: this.currSid,
      })
        .then((response) => {
          const res = response.data
          console.debug('response:', res)
          if (res.status === 0) {
            if (res.data) {
              let selectIndex = 0
              this.delegationArr = res.data.map((item, itemIndex) => {
                if (
                  this.currPlayerIndexPage &&
                  this.currPlayerIndexPage.delegationId &&
                  this.currPlayerIndexPage.delegationId ===
                    item.organisationCode
                ) {
                  selectIndex = itemIndex
                }
                return {
                  value: item.organisationCode,
                  name: item.organisationName,
                }
              })
              this.currStageDelegation = this.delegationArr[selectIndex].value
              console.debug('selectIndex:', selectIndex)
              this.actSelectIndexArr = this.actSelectIndexArr.map(
                (select, index) => {
                  if (index === 0) {
                    select = selectIndex
                  }
                  return select
                }
              )
            } else {
              console.debug('暂无数据')
              this.delegationArr = []
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getBigSportsList() {
      await https_sportsList(this.axiosBaseUrl, this.$axios, {
        sid: this.currSid,
      })
        .then((response) => {
          const res = response.data
          console.debug('response:', res)
          if (res.status === 0) {
            if (res.data) {
              let selectIndex = 0
              this.bigSportsArr = res.data.map((item, itemIndex) => {
                if (
                  this.currPlayerIndexPage &&
                  this.currPlayerIndexPage.sportsId &&
                  this.currPlayerIndexPage.sportsId === item.disciplineCode
                ) {
                  selectIndex = itemIndex
                }
                return {
                  value: item.disciplineCode,
                  name: item.disciplineName,
                }
              })
              console.debug('selectIndex:', selectIndex)
              this.currStageBigSports = this.bigSportsArr[selectIndex].value
              this.actSelectIndexArr = this.actSelectIndexArr.map(
                (select, index) => {
                  if (index === 1) {
                    select = selectIndex
                  }
                  return select
                }
              )
            } else {
              this.bigSportsArr = []
              console.debug('暂无数据')
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#compreSportsMeet_players {
  .select_area {
    position: relative;
    padding-top: 2.778vw;
    width: 100%;
    height: 9.028vw;
    .switch_area {
      position: absolute;
      top: 2.778vw;
      right: 0;
      z-index: 10;
    }
  }

  .teamTable {
    padding: 1.388vw 0 6.964vw;
    .tableScrollArea {
      position: relative;
      .match_label_fixed {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 100;
        width: 100%;
        height: 3.472vw;
        background-color: var(--mixtmt_whiteColor);
        .match_label {
          width: 100%;
          height: 3.472vw;
          background-image: var(--mixtmt_scheduleMatchList_dateBg);
          background-size: 100% auto;
          background-position: left top;
          background-repeat: no-repeat;

          .label_textArea {
            position: absolute;
            left: 0;
            top: 0.347vw;
            z-index: 2;
            width: 21.55%;
            padding-top: 0.6%;
            font-size: 1.38vw;
            color: var(--mixtmt_whiteColor);
            display: flex;
            display: -webkit-flex;
            justify-content: center;
            align-items: center;
            .labelIcon {
              width: 1.8vw;
              height: 1.8vw;
              overflow: hidden;
              margin-right: 0.694vw;
              background-color: #ccc;
            }
            & .letterSpa {
              letter-spacing: 0.4vw;
            }
          }
          .label_rightArea {
            position: absolute;
            right: 0;
            top: 0.347vw;
            z-index: 2;
            width: auto;
            display: flex;
            display: -webkit-flex;
            justify-content: flex-start;
            align-items: center;
            color: var(--mixtmt_greyColor3);
            .rightArea_name,
            .rightArea_value {
              font-size: 1.11vw;
            }
            .rightArea_value {
              width: 2.5vw;
              text-align: center;
            }
          }
        }
      }
      .scrollDomContain {
        /* max-height: calc(100vh - 19.142vw);
        overflow: auto; */
        padding-bottom: 1.388vw;
        .players_list {
          width: 100%;
          height: auto;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          flex-wrap: wrap;
        }
      }
    }
  }

  .loadingClass,
  .noMoreClass,
  .noDataClass {
    position: absolute;
    bottom: -4.166vw;
    left: 0;
    z-index: 2;
    width: 100%;
    line-height: 4.166vw;
    text-align: center;
    font-size: 0.972vw;
    color: var(--mixtmt_greyColor2);
  }
  .noDataClass {
    border-top: 1px solid var(--mixtmt_greyColor0);
    border-bottom: 1px solid var(--mixtmt_greyColor0);
  }
}
</style>
